<section class="section">
  @if (loadingState.remaining > 0) {
    <loader [detailed]="true" [small]="true" [text]="loadingState.asText"></loader>
  }
  @for (subscription of subscriptions(); track subscription.subscriptionId) {
    <div class="row">
      <div class="col-12">
        <wireless-element [subscription]="subscription" [orgTickets]="tickets()" />
      </div>
    </div>
  }
</section>
